import { OfficeData } from 'chaika-frontend-types/frontend-cms';
import { OfficeScheduleSettingsViewModel } from 'chaika-types';

interface Params {
    isHeadOfClinic: boolean;
    hasRootAccess: boolean;
    isPracticeLeader: boolean;
    isAssistant: boolean;
    currentUserId: string;
    organizationId?: string;
    offices: OfficeData[];
    settingsByOffice: Map<string, OfficeScheduleSettingsViewModel>;
}

export function hasClinicsAccess({
    isHeadOfClinic,
    hasRootAccess,
    isPracticeLeader,
    isAssistant,
    currentUserId,
    organizationId,
    offices,
    settingsByOffice,
}: Params): boolean {
    if (isHeadOfClinic || hasRootAccess || isPracticeLeader || isAssistant) {
        return true;
    }

    if (!organizationId) {
        return false;
    }

    return offices.some(office => settingsByOffice.get(office.id)?.userId === currentUserId);
}
